// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg > g > g.google-visualization-tooltip {\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
